/**
 * Resource icons — one small transparent WebP per `ResourceType` (public/resources/, 128px, generated art).
 *
 * Used next to the text label (building cost lists, battle log), never instead of it: the `<img>` is decorative
 * (`alt=""`, aria-hidden) because the label already names the resource. Sized in `em` so it follows the surrounding
 * text, which is why the markup carries its own width/height rather than relying on a class.
 */
export const RESOURCE_ICON_SRC: Record<string, string> = {
  REGOLITH: '/resources/res-regolith.webp',
  WATER_ICE: '/resources/res-water.webp',
  HE3: '/resources/res-he3.webp',
  COMPOSITE: '/resources/res-composite.webp',
  CRIMSON_DUST: '/resources/res-crimson.webp',
};

/** `<img>` markup for a resource, or '' for a type with no art (the caller keeps its text label either way). */
export function resourceIcon(type: string, sizeEm = 1.25): string {
  const src = RESOURCE_ICON_SRC[type];
  if (!src) return '';
  return `<img src="${src}" alt="" aria-hidden="true" width="128" height="128" loading="lazy" decoding="async" class="inline-block shrink-0 object-contain align-[-0.3em]" style="width:${sizeEm}em;height:${sizeEm}em" />`;
}
